// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XSSKo","toggleWrap":"styles_toggleWrap__3g58v","content":"styles_content__1VCb0","selectAreaCode":"styles_selectAreaCode__2_2iN"};